import React, { useEffect, useRef, useState } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import MainSidebar from "../../../Layout/MainSidebar";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import GroupAdminSidebar from "../../../Layout/GroupAdminSidebar";
import { useUser } from "../../../context/AuthContext";
import {
  Box,
  Button,
  PaginationItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import PaginationBox from "../../../Components/Masters/Pagination";
import styled from "styled-components";
import AddGhg from "./AddGhg";
import { get } from "../../../utils/api";
const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  "&.Mui-selected": {
    backgroundColor: "green",
    color: "#fff",
    fontWeight: "bold",
  },
  "&:hover": {
    backgroundColor: "#ededed",
  },
}));

const commonCellStyle = {
  padding: "8px",
  fontFamily: "Inter",
  fontSize: "16px",
  fontWeight: "400",
  border: "1px solid #DBDBDB",
  color: "#222222",
};

const headerCellStyle = {
  ...commonCellStyle,
  fontWeight: "600",
  fontSize: "18px",
  whiteSpace: "nowrap",
  letterSpacing: "0.5px",
};

const actionCellStyle = {
  ...commonCellStyle,
  textDecoration: "underline",
  cursor: "pointer",
};

const GhgList = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [data, setData] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const tableContainerRef = useRef(null);
  const [isShortContent, setIsShortContent] = useState(false);

  const fetchReportData = async () => {
    try {
      const response = await get(`/ghg-report/get?page=${page}&limit=10`);
      setData(response?.data?.data);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchReportData();
  }, [page]);

  return (
    <MainDashboardLayout
      sidebar={user?.groupManager ? <GroupAdminSidebar /> : <MainSidebar />}
    >
      <Unauthorized requiredModule="GHG Report">
        <>
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          <AddGhg
            handleClose={() => {
              setIsModalOpen(false);
              fetchReportData();
            }}
            title="Waste Generated in Operations"
            addData={isModalOpen}
            addUrl={`scope3/wasteGeneratedInOperations/add`}
            updateUrl={`scope3/wasteGeneratedInOperations/update`}
            {...{
              setsnackOpen,
            }}
          />
          <Box
            item
            xs={6}
            sx={{
              paddingLeft: 0,
              display: "flex",
              justifyContent: "space-between",
              marginTop: "2rem",
            }}
          >
            <p
              style={{
                margin: "1rem 0",
                fontFamily: "Inter",
                fontSize: "22px",
                fontWeight: "700",
              }}
            >
              GHG Reports
            </p>
         { user?.groupManager || user?.subGroupManager ?null :  <Button
              variant="contained"
              endIcon={<AddIcon />}
              sx={{
                backgroundColor: "#1c486b",
                fontSize: "16px",
                textTransform: "none",
                fontFamily: "Inter",
                fontWeight: "500",
                height: "2.5rem",
                mt: "1rem",
                "&:hover": {
                  backgroundColor: "#1c486b",
                  opacity: 0.9,
                },
              }}
              onClick={() => setIsModalOpen(true)}
            >
              Add New
            </Button>}
          </Box>
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            style={{ marginTop: "1rem", backgroundColor: "#FCFCFC" }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  {[
                    "S.No",
                    "Reporting Year",
                    "Coverage",
                    "Create Date",
                    "Action",
                  ].map((header, index) => (
                    <TableCell key={index} style={headerCellStyle}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    <TableCell style={commonCellStyle}>
                      {(page - 1) * 10 + rowIndex + 1}
                    </TableCell>
                    <TableCell style={commonCellStyle}>
                      {row?.reportingYear}
                    </TableCell>
                    <TableCell style={commonCellStyle}>
                      {row?.typeOfReport === "Facility"
                        ? row?.facility?.facilityName
                        : row?.typeOfReport}
                    </TableCell>
                    <TableCell style={commonCellStyle}>
                      {new Date(
                        row.preparationDate ?? row.createdAt
                      ).toLocaleString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </TableCell>
                    <TableCell
                      style={actionCellStyle}
                      onClick={() => navigate(`/ghg-report/${row._id}?year=${row?.reportingYear}`)}
                    >
                      View
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
        </>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default GhgList;
